import { action, observable, computed, makeObservable } from 'mobx';
import { updateWalletAddressApi } from '../../../api/products-api';

export default class AccessKey {
  name;
  accountAddress;
  entity;
  isEnabled;

  constructor(key) {
    makeObservable(this, {
      name: observable,
      accountAddress: observable,
      entity: observable,
      isEnabled: observable,
      formattedAccountAddress: computed,
      update: action,
    });

    this.id = key.id;
    this.name = key.name;
    this.accountAddress = key.account_address;
    this.entity = key.entity;
    this.isEnabled = key.is_enabled;
    this.isPenalized = key.is_penalized;
  }

  get formattedAccessSecret() {
    return '••••••••••••••••••••';
  }

  get formattedAccountAddress() {
    return `•••••••••••${(this.accountAddress || '').slice(-8)}`;
  }

  get formattedAccessKey() {
    return this.formattedAccountAddress;
  }

  update = async (data) => {
    const response = await updateWalletAddressApi({
      id: this.id,
      ...data,
      entity: data.entity.id,
    });
    this.accountAddress = response.account_address;
    this.name = response.name;
    this.entity = data.entity;
    this.isEnabled = response.is_enabled;
  };
}
